import { render } from "./StudentHomework.vue?vue&type=template&id=770970a6&scoped=true"
import script from "./StudentHomework.vue?vue&type=script&lang=js"
export * from "./StudentHomework.vue?vue&type=script&lang=js"

import "./StudentHomework.vue?vue&type=style&index=0&id=770970a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770970a6"]])

export default __exports__